// Guarded wrapper around the GTM `dataLayer`. Initialize lazily so a push made
// before the container script loads is still picked up, and no-op without a
// `window` so callers never guard. This is for client-originated events the
// React checkout raises mid-session; server-originated experiment events go
// through the Ruby Analytics bus and the GTM adapter instead.

interface DataLayerWindow extends Window {
  dataLayer?: Array<Record<string, unknown>>
}

export function pushDataLayer(event: Record<string, unknown>): void {
  if (typeof window === 'undefined') {
    return
  }

  const w = window as DataLayerWindow
  w.dataLayer = w.dataLayer || []
  w.dataLayer.push(event)
}
